import { SchoolData } from "@nimble/candidate-api/types";
import { formatGradeRange } from "@nimble/ts-formatters/format-grade-range";

import { aboutThisSchoolTestIds } from "@/lib/data-test-ids/schools.data-test-ids";

export interface AboutThisSchoolProps {
  schoolData: SchoolData;
}

export default function AboutThisSchool({ schoolData }: AboutThisSchoolProps) {
  return (
    <div data-testid={aboutThisSchoolTestIds.ABOUT_THIS_SCHOOL}>
      <h3 className="text-sm font-bold text-foreground mb-3">
        About this school
      </h3>
      <div className="grid grid-cols-1 gap-3 text-sm">
        {schoolData.principal?.first_name &&
          schoolData.principal?.last_name && (
            <div
              className="flex flex-col lg:flex-row lg:items-center lg:justify-between"
              data-testid={aboutThisSchoolTestIds.ABOUT_THIS_SCHOOL_PRINCIPAL}
            >
              <span className="text-ink-subtle">Principal</span>
              <span className="font-medium text-foreground">
                {schoolData.principal.first_name}{" "}
                {schoolData.principal.last_name}
              </span>
            </div>
          )}
        {schoolData.physical_address?.city &&
          schoolData.physical_address?.state && (
            <div
              className="flex flex-col lg:flex-row lg:items-center lg:justify-between"
              data-testid={aboutThisSchoolTestIds.ABOUT_THIS_SCHOOL_LOCATION}
            >
              <span className="text-ink-subtle">Location</span>
              <span className="font-medium text-foreground">
                {schoolData.physical_address.city},{" "}
                {schoolData.physical_address.state}
              </span>
            </div>
          )}
        {Array.isArray(schoolData.grades) && schoolData.grades.length > 0 && (
          <div
            className="flex flex-col lg:flex-row lg:items-center lg:justify-between"
            data-testid={aboutThisSchoolTestIds.ABOUT_THIS_SCHOOL_GRADES}
          >
            <span className="text-ink-subtle">Grades</span>
            <span className="font-medium text-foreground">
              {formatGradeRange(
                schoolData.grades.filter((g): g is string => Boolean(g)),
              )}
            </span>
          </div>
        )}
        {schoolData.school_metadata?.student_count != null &&
          schoolData.school_metadata.student_count > 0 && (
            <div
              className="flex flex-col lg:flex-row lg:items-center lg:justify-between"
              data-testid={aboutThisSchoolTestIds.ABOUT_THIS_SCHOOL_STUDENTS}
            >
              <span className="text-ink-subtle">Students</span>
              <span className="font-medium text-foreground">
                {schoolData.school_metadata.student_count}
              </span>
            </div>
          )}
        {schoolData.school_metadata?.school_type && (
          <div
            className="flex flex-col lg:flex-row lg:items-center lg:justify-between"
            data-testid={aboutThisSchoolTestIds.ABOUT_THIS_SCHOOL_TYPE}
          >
            <span className="text-ink-subtle">Type</span>
            <span className="font-medium text-foreground">
              {schoolData.school_metadata.school_type}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
